import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["delayShow", "mouseEnterDelay", "delayHide", "mouseLeaveDelay"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Dropdown from './Dropdown';
import DropdownButton from "./DropdownButton";
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;

var DropdownWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownWrapper, _React$Component);

  var _super = _createSuper(DropdownWrapper);

  function DropdownWrapper(props) {
    _classCallCheck(this, DropdownWrapper);

    return _super.call(this, props);
  }

  _createClass(DropdownWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          delayShow = _this$props.delayShow,
          mouseEnterDelay = _this$props.mouseEnterDelay,
          delayHide = _this$props.delayHide,
          mouseLeaveDelay = _this$props.mouseLeaveDelay,
          others = _objectWithoutProperties(_this$props, _excluded);

      isShouldUpdate("Dropdown", this.props);
      var extral = {
        delayShow: mouseEnterDelay ? mouseEnterDelay : delayShow,
        delayHide: mouseLeaveDelay ? mouseLeaveDelay : delayHide
      };
      return /*#__PURE__*/React.createElement(Dropdown, _extends({}, extral, others));
    }
  }]);

  return DropdownWrapper;
}(React.Component);

DropdownWrapper.Button = DropdownButton;
export default DropdownWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-dropdown/src/index.js